module.exports = __webpack_public_path__ + "static/About Image 1-7a96f6c3c024d336d896f51f9f7bc245.jpg";